import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { JobList, Job, Mechanic, NoteListEntity} from '../models/interfaces'
import { MechanicJobs } from '../models/mechanic';

export interface MechanicLoad {
  id: number;
  name: string;
  toStart: number;
  running: number;
  blocked: number;
  total: number;
}


@Injectable({
  providedIn: 'root'
})
export class MechanicService {

constructor(private http: HttpClient ) { }




public getAllMechanics(): Observable<Mechanic[]> {
  return this.http.get<Mechanic[]>(environment.APIENDPOINT + '/mechanics', {
    headers: this.setHeaders(),
    responseType: 'json'
  });
}

public getMechanicLoad(): Observable<MechanicLoad[]> {
  return this.getAllMechanics().pipe(
    switchMap(mechanics => {
      const calls = mechanics.map(m =>
        this.http.get<MechanicJobs>(environment.APIENDPOINT + '/mechanics/' + m.id, {
          headers: this.setHeaders(),
          responseType: 'json'
        }).pipe(
          map(dto => ({
            id: m.id,
            name: (m.firstName + ' ' + m.lastName).trim(),
            toStart:  dto.numberOfJobsToStart || 0,
            running:  dto.numberOfRunningJobs  || 0,
            blocked:  dto.numberOfBlockedJobs  || 0,
            total:   (dto.numberOfJobsToStart || 0) + (dto.numberOfRunningJobs || 0) + (dto.numberOfBlockedJobs || 0)
          } as MechanicLoad))
        )
      );
      return forkJoin(calls);
    })
  );
}

public getMechanicJobs(mechanicID : number) : Observable<MechanicJobs>{

  return this.http.get<MechanicJobs>(environment.APIENDPOINT + '/mechanics/' + mechanicID + '?statuses=2,3' , {
    headers: this.setHeaders(),
    responseType: 'json'
  });

}



  updateNote(jobId: number, taskId: number, noteId: number, note: NoteListEntity){
    return this.http.post(environment.APIENDPOINT +  '/jobs/'+ jobId +'/tasks/' + taskId + '/notes/' + noteId, note, 
    {
        headers: this.setHeaders(),
        responseType: 'json'
    }
    );
  }



  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}